/**
 * Validation utilities for form inputs
 */

/**
 * Validates customer number - must be exactly 8 digits
 * @param {string} value - The value to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const validateCustomerNumber = (value) => {
  if (!value) return false;
  const trimmed = value.trim();
  return /^\d{8}$/.test(trimmed);
};

/**
 * Validates assignment number - must be exactly 10 digits
 * @param {string} value - The value to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const validateAssignmentNumber = (value) => {
  if (!value) return false;
  const trimmed = value.trim();
  return /^\d{10}$/.test(trimmed);
};

/**
 * Validates email format
 * @param {string} email - The email to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const validateEmail = (email) => {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validates phone number format
 * @param {string} phone - The phone number to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const validatePhoneNumber = (phone) => {
  if (!phone) return false;
  const phoneRegex = /^[\d\s+()-]+$/;
  return phoneRegex.test(phone) && phone.replace(/\D/g, '').length >= 10;
};

/**
 * Validates if a field is not empty
 * @param {string} value - The value to validate
 * @returns {boolean} - True if not empty, false otherwise
 */
export const validateRequired = (value) => {
  return value && value.trim().length > 0;
};

/**
 * Validates minimum length
 * @param {string} value - The value to validate
 * @param {number} minLength - Minimum length required
 * @returns {boolean} - True if valid, false otherwise
 */
export const validateMinLength = (value, minLength) => {
  return value && value.trim().length >= minLength;
};

/**
 * Validates maximum length
 * @param {string} value - The value to validate
 * @param {number} maxLength - Maximum length allowed
 * @returns {boolean} - True if valid, false otherwise
 */
export const validateMaxLength = (value, maxLength) => {
  return !value || value.trim().length <= maxLength;
};
